/**
 * This class has methods to Minify and Beautify XML string
 * Minify: This method make input XML payload one-liner
 * Beautify: This method returns XML payload having proper indentation and make it more readable
 */
export default class XmlBeautify{

    public static beautify(xml: string): string {
        if(!this.isValidXML(xml)){
            return xml;
        }
        const indent = 3;
        const arr = xml.replace(/>\s*</gm, '><').replace(/</g, '~::~<').split('~::~');
        const len = arr.length;
        const shift = XmlBeautify.createShiftArr(indent);

        let inComment = false;
        let depth = 0;
        let res = '';
        for (let i = 0; i < len; i++) {
            // start comment or <![CDATA[...]]> or <!DOCTYPE //
            if (arr[i].indexOf('<!') !== -1) {
                res += shift[depth] + arr[i];
                inComment = true;
                // end comment or <![CDATA[...]]> //
                if (arr[i].indexOf('-->') !== -1 || arr[i].indexOf(']>') !== -1 ||
                    arr[i].indexOf('!DOCTYPE') !== -1) {
                    inComment = false;
                }
            } else if (arr[i].indexOf('-->') !== -1 || arr[i].indexOf(']>') !== -1) { // end comment  or <![CDATA[...]]> //
                res += arr[i];
                inComment = false;
            } else if (/^<\w/.test(arr[i - 1]) && /^<\/\w/.test(arr[i]) && // <elm></elm> //
                /^<[\w:\-.,]+/.exec(arr[i - 1])[0] === /^<\/[\w:\-.,]+/.exec(arr[i])[0].replace('/', '')) {
                res += arr[i];
                if (!inComment) {depth--;}
            } else if (arr[i].search(/<\w/) !== -1 && arr[i].indexOf('</') === -1 && arr[i].indexOf('/>') === -1) // <elm> //
                {res += !inComment ? (shift[depth++] + arr[i]) : arr[i];}
            else if (arr[i].search(/<\w/) !== -1 && arr[i].indexOf('</') !== -1) // <elm>...</elm> //
                {res += !inComment ? shift[depth] + arr[i] : arr[i];}
            else if (arr[i].search(/<\//) > -1) // </elm> //
                {res += !inComment ? shift[--depth] + arr[i] : arr[i];}
            else if (arr[i].indexOf('/>') !== -1) // <elm/> //
                {res += !inComment ? shift[depth] + arr[i] : arr[i];}
            else if (arr[i].indexOf('<?') !== -1) // <? xml ... ?> //
                {res += shift[depth] + arr[i];}
            else if (arr[i].indexOf('xmlns:') !== -1 || arr[i].indexOf('xmlns=') !== -1) // xmlns //
                {res += shift[depth] + arr[i];}
            else
                {res += arr[i];}
        }
        return res.trim();
    }

    public static minify(xml: string): string {
        if(!this.isValidXML(xml)){
            return xml;
        }
        return this.beautify(xml).replaceAll('\n', '').replaceAll(/>\s{0,}</g, '><');
    }

    private static createShiftArr(step: number): string[] {
        let space = '';
        for (let i = 0; i < step; i++)
            {space += ' ';}
        const shift = ['\n'];
        for (let ix = 0; ix < 100; ix++)
            {shift.push(shift[ix] + space);}
        return shift;
    }

    private static isValidXML(xml: string): boolean {
        const doc = new DOMParser().parseFromString(xml, 'text/xml');
        return !doc.querySelector('parsererror');
    }
}
